<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="1200px">
    <v-card>
      <v-card-title>
        <span class="headline">{{title}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>

          <v-data-table
              :headers="header"
              :items="gridList"
              sort-by="revenue_date"
              :hide-default-footer="true"
              :disable-pagination="true"
              class="elevation-1">
            <template v-slot:item="{item}">
              <tr>
                <td>{{ item.reference_id }}</td>
                <td>{{ item.price | currency('', 0, { symbolOnLeft: false }) }} ریال</td>
                <td>{{ convertDateToJDate(item.revenue_date) }}</td>
                <td>{{ getObjectNameById(accounts,'account_id',item.account_id) }}</td>
                <td>{{ getObjectNameById(categories,'category_id',item.revenue_category_id) }}
                </td>
                <td>{{ item.description }}</td>
                <td>{{ item.added_user_name }}</td>
              </tr>
            </template>
          </v-data-table>


          <v-layout wrap>
            <v-flex xs12 sm4 md4>
              <CInput
                  label="شماره پیگیری"
                  v-model="editedItem.reference_id"
              />

            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <label>تاریخ</label>
                <date-picker v-model="editedItem.revenue_date"
                             type="datetime"
                             input-format="YYYY-MM-DD HH:mm:ss"
                             locale="fa" format="YYYY-MM-DD"
                             display-format="jYYYY-jMM-jDD HH:mm:ss">
                </date-picker>
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <label>حساب</label>
                <v-autocomplete
                    v-model="editedItem.account_id"
                    :items="accounts"
                    :item-text="(item)=>{return item.name}"
                    :item-value="(item)=>{return item.account_id}"
                    dense
                />
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <CInput
                    label="شناسه شخص"
                    v-model="editedItem.contact_id"
                />
                <contact-searcher v-model="editedItem.contact_id"></contact-searcher>
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <CInput
                  label="شناسه مشتری"
                  v-model="editedItem.customer_id"
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <CInput
                    label="شناسه فاکتور فروش"
                    v-model="editedItem.invoice_id"
                />
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <label>مبلغ</label>
                <money v-model="editedItem.price" v-bind="money" dir="ltr"
                       class="form-control"/>
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <label>زیرمجموعه</label>
                <v-autocomplete
                    v-model="editedItem.revenue_category_id"
                    :items="categories"
                    :item-text="(item)=>{return item.name}"
                    :item-value="(item)=>{return item.category_id}"
                    dense
                />
              </div>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <div class="form-group">
                <label>فایل ضمیمه</label>
                <v-file-input dense v-model="editedItem.fileUpload"/>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8>
              <CTextarea
                  label="توضیحات"
                  v-model="editedItem.description"
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              مانده:
              {{ this.price - this.revenue_price | currency(' ریال', 0, { symbolOnLeft: false }) }}
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CButton color="danger" class="mb-2 ml-2 text-white"
                 @click="close">
          انصراف
        </CButton>
        <CButton color="primary" class="mb-2 ml-2 text-white"
                 @click="save">
          ذخیره
        </CButton>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

import {functionAction, getFunction, uploadFile} from "@/webservice/webservice";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import moment from "moment-jalaali";

export default {
  name: "RevenueForm",
  components: {
    datePicker: VuePersianDatetimePicker
  },
  props: ['title','action','value','invoice_id','revenue_date','contact_id','customer_id','price','revenue_price','categories','accounts'],
  data: () => ({
    money: {
      decimal: '',
      thousands: ',',
      prefix: '',
      suffix: '',
      precision: 0,
      masked: false
    },
    editedItem: {
      "revenue_id": "",
      "revenue_date": "",
      "price": "",
      "account_id": "",
      "customer_id": "",
      "contact_id": "",
      "reference_id": "",
      "description": "",
      "revenue_category_id": "",
      "invoice_id": "",
      "attachment": ""
    },
    header: [
      {text: 'شماره پیگیری', value: 'reference_id'},
      {text: 'مبلغ', value: 'price'},
      {text: 'تاریخ', value: 'revenue_date'},
      {text: 'حساب', value: 'account_id'},
      {text: 'زیرمجموعه', value: ''},
      {text: 'توضیحات', value: 'description'},
      {text: 'کاربر اضافه کننده', value: 'added_user_name'},

    ],
    gridList: []
  }),
  methods: {
    save() {

      //let action = this.editedIndex === -1 ? 'add' : 'update';
      Object.keys(this.editedItem).map((key) => {
        if (this.editedItem[key] === null) {
          this.editedItem[key] = ""
        }
      });
      let self = this;
      if (this.editedItem.fileUpload) {
        uploadFile(this.$http, this.editedItem.fileUpload).then((resp) => {
          self.editedItem.attachment = resp.filename;
          delete self.editedItem.fileUpload;
          if (action === 'add') {
            self.editedItem.bill_id = ''
          }
          self.saveEditItem(this.action);
        })
      } else {
        //console.log(this.editedItem);
        this.saveEditItem(this.action)
      }
    },
    saveEditItem(action) {
      functionAction(this.$http, 'revenues', action, this.editedItem).then((resp) => {
        if (resp.success) {
          this.$toasted.show(resp.message, {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000
          });
          //this.editedItem = Object.assign({}, this.defaultItem);
          this.refreshRevenues()
        } else {
          let errors = resp.body.errors;
          this.$toasted.show(resp.body.message, {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000
          });
        }
      });
    },
    close(){
      //this.editedItem = Object.assign({}, this.defaultItem);
      this.$emit('input');

      //this.dialog = false;
      /*
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);

      })
      */
    },
    refreshRevenues() {
      let filters = {invoice_id:this.invoice_id};
      getFunction(this.$http, 'revenues', 0, 1000,'revenue_id','asc', filters).then((resp) => {
          this.gridList = resp.list;
          this.revenue_price = resp.balance;
          var r_price = (this.revenue_price == null ? 0 : this.revenue_price);
          this.editedItem.price = (this.price - r_price);
      });
    },
    convertDateToJDate(dt) {
      let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD  HH:mm:ss');
      if (convertedDate === 'Invalid date') {
        return 'نامعلوم'
      }
      return convertedDate
    },
    getObjectNameById(list, key, id, extraKey) {
      for (let i = 0; i < list.length; i++) {
        //console.log(list[i][key], id);
        if (list[i][key] === id) {
          if (extraKey) {
            return list[i].name + ' ' + list[i][extraKey]
          }
          return list[i].name
        }
      }
    },
  },
  mounted(){

  },
  watch: {
    value: function (val) {
      if(val) {
        this.editedItem.invoice_id = this.invoice_id;
        this.editedItem.revenue_date = this.revenue_date;
        this.editedItem.contact_id = this.contact_id;
        this.editedItem.customer_id = this.customer_id;
        var r_price = (this.revenue_price == null ? 0 : this.revenue_price);
        this.editedItem.price = (this.price - r_price);
        this.refreshRevenues();
      }
    }



  }}
</script>

<style scoped>

</style>